import { Box, Button } from "@mui/material";
import { Add } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { PathConstant } from "@/const";

const UserActions = () => {
  const { t: getLabel } = useTranslation();

  return (
    <Box>
      <Button component={Link} to={PathConstant.MN_USER_NEW} variant="contained" startIcon={<Add />}>
        {getLabel("L_ADD")}
      </Button>
    </Box>
  );
};

export default UserActions;
